var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeFileContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.051,
    height: 18.5,
    viewBox: "0 0 13.051 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-contract",
    "data-name": "Icon awesome-file-contract",
    d: "M7.613,4.914V0H.816A.841.841,0,0,0,0,.867V17.633a.841.841,0,0,0,.816.867h11.42a.841.841,0,0,0,.816-.867V5.781H8.429A.845.845,0,0,1,7.613,4.914ZM2.175,2.6a.281.281,0,0,1,.272-.289H5.166a.281.281,0,0,1,.272.289V3.18a.281.281,0,0,1-.272.289H2.447a.281.281,0,0,1-.272-.289Zm0,2.313a.281.281,0,0,1,.272-.289H5.166a.281.281,0,0,1,.272.289v.578a.281.281,0,0,1-.272.289H2.447a.281.281,0,0,1-.272-.289Zm6.553,8.961h1.6a.579.579,0,0,1,0,1.156h-1.6a1.455,1.455,0,0,1-1.313-.862.374.374,0,0,0-.346-.236.367.367,0,0,0-.341.224l-.261.554a.541.541,0,0,1-.486.319l-.039,0a.549.549,0,0,1-.477-.393l-.572-1.823-.361,1.152A1.478,1.478,0,0,1,3.14,15.031H2.719a.579.579,0,0,1,0-1.156H3.14A.384.384,0,0,0,3.5,13.6l.618-1.974a.8.8,0,0,1,1.548,0l.472,1.5a1.476,1.476,0,0,1,2.243.512A.387.387,0,0,0,8.728,13.875ZM12.813,3.794,9.486.253A.791.791,0,0,0,8.908,0H8.7V4.625h4.35V4.4A.893.893,0,0,0,12.813,3.794Z",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeFileContract);
export default __webpack_public_path__ + "static/media/Icon awesome-file-contract.98b78d7fd603838ad255e2c41dd73f37.svg";
export { ForwardRef as ReactComponent };